import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import { logOut } from '../util'
import SimpleTextDialog from "../dialogs/simple-text-dialog";

export default function AttributeValueContextMenu({ token, setToken, anchorEl, setAnchorEl, anchorData, setAnchorData, setAttributeValueList }) {
    let [editNameDialogOpen, setEditNameDialogOpen] = useState(false);
    const open = Boolean(anchorEl);
    let navigate = useNavigate()

    const handleEditName = () => {
        setAnchorEl(null)
        setEditNameDialogOpen(true)
    };

    const handleClose = () => {
        setAnchorEl(null);
        setAnchorData(null);
    };

    const deleteAttributeValue = () => {
        fetch('/api/attribute-values/' + anchorData._id, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (response.status !== 200) {
                    if (response.status === 401) {
                        logOut({ navigate, setToken })
                    }
                    return alert("attribute-value not deleted");
                } else {
                    setAttributeValueList(attributeValues => attributeValues.filter(attributeValue => attributeValue._id !== anchorData._id))
                    handleClose()
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <React.Fragment>
            <Menu
                id="attribute-value-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleEditName}>Edit</MenuItem>
                <MenuItem onClick={deleteAttributeValue} sx={{ color: 'firebrick' }}>Delete</MenuItem>
            </Menu>
            <SimpleTextDialog
                token={token}
                setToken={setToken}
                open={editNameDialogOpen}
                setOpen={setEditNameDialogOpen}
                handleCloseExternal={handleClose}
                apiEndpoint={'/api/attribute-values/' + anchorData?._id}
                value={anchorData}
                setValue={setAttributeValueList}
                dialogTitle={"Edit attribute value name"}
                dbFieldname={"name"}
                inputLabel={"Name"}
                entityId={anchorData?._id}
                accountId={anchorData?.accountId}
            />
        </React.Fragment>
    );
}
